import React from 'react';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';

import { cn } from '@utils/styles';
import { getImageUrl } from '@utils/nutrition/getImageUrl';

interface BoostersBlockersHealthCardProps {
  description: string;
  images: string[];
  count: number;
  onClick: () => void;
}

export const BoostersBlockersHealthCard: React.FC<
  BoostersBlockersHealthCardProps
> = ({ description, images = [], count, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'p-5 bg-white text-black rounded-lg shadow-md items-center w-full text-left transition-transform focus:outline-none',
      )}
    >
      {/* Content Section */}
      <div>
        <h3 className="typography-title">
          My Boosters & Blockers
        </h3>
        <p className="typography-body text-stroke-primary-bold rmt-2 max-w-[37rem]">
          {description}
        </p>
        <div className="flex justify-between items-end">
          <div className="flex mt-4">
            {images.length > 0 &&
              images.map((image, index) => (
                <img
                  key={`${image}-${index}-booster-img`}
                  src={getImageUrl(image)}
                  alt={`booster-${index}`}
                  className="w-14 h-14 rounded-full border border-secondary mr-[-16px]"
                />
              ))}
          </div>

          <div className="flex items-center transition-colors">
            <span className="typography-caption1">{`Show +${count} more`}</span>
            <ChevronRightIcon className="ml-1" />
          </div>
        </div>
      </div>
    </button>
  );
};
